import { render, staticRenderFns } from "./IrisTable.vue?vue&type=template&id=1ad12488&"
import script from "./IrisTable.vue?vue&type=script&lang=ts&async=true&"
export * from "./IrisTable.vue?vue&type=script&lang=ts&async=true&"
import style0 from "./IrisTable.vue?vue&type=style&index=0&id=1ad12488&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports